export const emailAddresses = {
  support: 'support@flixpremiere.com',
}

export const localPhoneNumbers = {
  US: '(310) 601 3168',
  GB: '02045 348260',
}

export const phoneNumbers = {
  US: '+1 (310) 601 3168',
  GB: '+44 2045 348260',
}
